export default function () {
    const swiperOptions = {

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.imagery-swiper-navigation-button.next',
            prevEl: '.imagery-swiper-navigation-button.prev',
        },
    };
    new Swiper('.swiper-imagery', swiperOptions);
}
